import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import { IoCloseOutline } from 'react-icons/io5';
import './Hero.css';

const Hero = () => {

  const [isFormOpen, setIsFormOpen] = useState(false);

  const [formData, setFormData] = useState({
    name: '',
    mobile: '',
    email: '',
    destination: '',
    month: '',
    travelers: '',
    message: ''
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {

    e.preventDefault();

    setLoading(true);

    try {

      const response = await fetch(
        "http://localhost:5000/send-email",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(formData)
        }
      );

      const data = await response.json();

      alert(data.message);

      setFormData({
        name: '',
        mobile: '',
        email: '',
        destination: '',
        month: '',
        travelers: '',
        message: ''
      });

      setIsFormOpen(false);

    } catch (error) {

      alert("Something Went Wrong");

    }

    setLoading(false);
  };

  return (
    <section className="hero-section">

      {/* Premium Background with subtle Zoom */}
      <div className="hero-bg-stack">

        <motion.div
          className="hero-bg-image"
          initial={{ scale: 1.2 }}
          animate={{ scale: 1 }}
          transition={{ duration: 2, ease: "easeOut" }}
        />

        <div className="hero-dark-overlay" />

      </div>

      {/* Center Content */}
      <div className="hero-main-wrapper">

        <motion.div
          className="hero-content-center"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: false }}
          transition={{ duration: 1, ease: "easeOut" }}
        >

          <motion.span
            className="hero-subtitle"
            initial={{ opacity: 0, letterSpacing: "0px" }}
            animate={{ opacity: 1, letterSpacing: "4px" }}
            transition={{ delay: 0.5, duration: 1 }}
          >
            A TRAVEL YOU'LL REMEMBER FOR A LIFETIME
          </motion.span>

          <h1 className="hero-title">
            Thoughtfully Planned Journeys,
            <br />
            <span className="accent-text">
              Designed Around You
            </span>
          </h1>

          <p className="hero-description">
            At Chandrama Holidays, we organize carefully planned domestic tours and customized international trips for
            <br />
            families, couples, and groups. We take care of everything so you can enjoy your journey
            <br />
            with personalized service and elite comfort.
          </p>

          <div className="hero-btns">

            <Link
              to="/holiday#domestic-packages"
              className="btn-sun-filled"
            >
              EXPLORE TOURS
            </Link>

            <button
              className="btn-glass-outline"
              onClick={() => setIsFormOpen(true)}
            >
              PLAN MY TRIP
            </button>

          </div>

        </motion.div>

      </div>

      {/* FORM */}
      <AnimatePresence>

        {isFormOpen && (

          <div className="form-fixed-container">

            <motion.div
              className="form-backdrop"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={() => setIsFormOpen(false)}
            />

            <motion.div
              className="luxury-form-card"
              initial={{ y: "-100vh", opacity: 0 }}
              animate={{ y: "0", opacity: 1 }}
              exit={{ y: "-100vh", opacity: 0 }}
              transition={{
                type: "spring",
                damping: 25,
                stiffness: 120
              }}
            >

              <button
                className="close-form-btn"
                onClick={() => setIsFormOpen(false)}
              >
                <IoCloseOutline />
              </button>

              <div className="form-header-premium">

                <h3>Plan Your Escape</h3>

                <p>
                  Fill in the details to get a customized luxury quote.
                </p>

              </div>

              <form
                className="vertical-stack-form"
                onSubmit={handleSubmit}
              >

                <div className="input-group">

                  <input
                    type="text"
                    name="name"
                    placeholder="Full Name"
                    required
                    value={formData.name}
                    onChange={handleChange}
                  />

                  <input
                    type="tel"
                    name="mobile"
                    placeholder="Mobile Number"
                    required
                    value={formData.mobile}
                    onChange={handleChange}
                  />

                  <input
                    type="email"
                    name="email"
                    placeholder="Email ID"
                    required
                    value={formData.email}
                    onChange={handleChange}
                  />

                  <input
                    type="text"
                    name="destination"
                    placeholder="Destination"
                    required
                    value={formData.destination}
                    onChange={handleChange}
                  />

                  <select
                    name="month"
                    required
                    value={formData.month}
                    onChange={handleChange}
                  >

                    <option value="">
                      Month of travel
                    </option>

                    <option value="Jan-Mar">
                      Jan-Mar
                    </option>

                    <option value="Apr-Jun">
                      Apr-Jun
                    </option>

                    <option value="Jul-Sep">
                      Jul-Sep
                    </option>

                    <option value="Oct-Dec">
                      Oct-Dec
                    </option>

                  </select>

                  <input
                    type="number"
                    name="travelers"
                    placeholder="Number of travelers"
                    required
                    value={formData.travelers}
                    onChange={handleChange}
                  />

                  <textarea
                    name="message"
                    placeholder="Share your destination / Travel details"
                    rows="3"
                    value={formData.message}
                    onChange={handleChange}
                  />

                </div>

                <button
                  type="submit"
                  className="luxury-submit-btn"
                  disabled={loading}
                >

                  {
                    loading
                      ? "Sending..."
                      : "SEND ENQUIRY"
                  }

                </button>

                <p className="contact-disclaimer">
                  Our team will contact you within 24 hours.
                </p>

              </form>

            </motion.div>

          </div>

        )}

      </AnimatePresence>

    </section>
  );
};

export default Hero;